import type { ItemType } from "@/types/item";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

const fetchCategoryItems = async (
  categoryId: string,
  lang: string
): Promise<ItemType[]> => {
  const response = await axios.get(
    `https://kaman.rest/api/items?category_id=${categoryId}&lang=${lang}`
  );
  return response.data.data.items;
};

export const useCategoryItems = (categoryId: string) => {
  const { i18n } = useTranslation();

  return useQuery<ItemType[]>({
    queryKey: ["category", categoryId],
    queryFn: () => fetchCategoryItems(categoryId, i18n.language),
    enabled: !!categoryId,
  });
};
